import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import type { UserContextProps } from "src/types";
import type { usePersistedAppStore } from "src/hooks";

export const UserContext = createContext<UserContextProps>({});

type UserProviderValue = ReturnType<typeof usePersistedAppStore>;

export const UserProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: UserProviderValue; // Use the inferred type directly here
}) => {
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
